module.exports = __webpack_public_path__ + "static/img/smartControl13.526fdcde.png";